import env from './environment';

const url = {
  testing: 'localhost',
  development: 'dev.dashboard.evntl.com',
  dev: 'dev.dashboard.evntl.com',
  staging: 'staging.dashboard.evntl.com',
  production: 'dashboard.evntl.com'
};

const port = {
  testing: 80,
  development: 8443,
  dev: 8443,
  staging: 443,
  production: 443
};

export default {
  url: url[env],
  port: port[env]
};
